<ng-container *ngIf="!esignLinkItem">
  <div class="blank-layout-container justify-content-center align-items-center" style="background: linear-gradient(to bottom, #004c7a 50%, #FAFAFA 50%);">
    <div class="position-relative row w-100 h-100 bg-gredient justify-content-center">
        <div class="col-lg-4 d-flex align-items-center">
          <mat-card class="cardWithShadow boxed-auth" style="border-radius: 20px;box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;">
            <mat-card-content class="p-0">
              <h4 class="f-w-700 f-s-20 m-0 m-t-30" style="text-align: center;">Signature électronique</h4>
              <div class="or-border m-t-8">Saisissez votre code de validation</div>
              <div style="margin: 20px;" (click)="focusHiddenInput()">
                  <!-- Champ caché pour déclencher clavier mobile -->
                  <input #hiddenInput type="tel" pattern="[0-9]*" inputmode="numeric" style="position:absolute; z-index:-1;" (input)="onInput($event)" maxlength="5" (blur)="refocusHiddenInput()" />
                  <div class="numpad-container">
                      <input type="text" class="numpad-field" readonly="readonly" [value]="!!esignCodeArray[0] ? esignCodeArray[0] : ''">
                      <input type="text" class="numpad-field" readonly="readonly" [value]="!!esignCodeArray[1] ? esignCodeArray[1] : ''">
                      <input type="text" class="numpad-field" readonly="readonly" [value]="!!esignCodeArray[2] ? esignCodeArray[2] : ''">
                      <input type="text" class="numpad-field" readonly="readonly" [value]="!!esignCodeArray[3] ? esignCodeArray[3] : ''">
                      <input type="text" class="numpad-field" readonly="readonly" [value]="!!esignCodeArray[4] ? esignCodeArray[4] : ''">
                  </div>
              </div>
              <div class="d-flex" style="margin: 12px;">
                  <button mat-flat-button [disabled]="esignCodeArray.length != 5 || showProgressBar" color="ccdark" (click)="doGetWCluDocumentESignLinkItemAction_PUPRemDocsESign()" style="font-weight: 700; border: 1px solid; margin-left: 10px; margin-right: 10px; flex: 1;">
                    <ng-container *ngIf="!showProgressBar">
                      VALIDER
                    </ng-container>   
                    <ng-container *ngIf="showProgressBar">
                      <mat-progress-spinner style="width: 20px;height: 20px!important;" [color]="'warn'" [mode]="'indeterminate'"></mat-progress-spinner>
                    </ng-container> 
                  </button>
              </div>
            </mat-card-content>
          </mat-card>
        </div>
    </div>
  </div>
</ng-container>
<ng-container *ngIf="esignLinkItem">
  <div class="blank-layout-container justify-content-center align-items-center" style="background: linear-gradient(to bottom, #004c7a 50%, #FAFAFA 50%);">
    <div class="position-relative row w-100 h-100 bg-gredient justify-content-center">
        <div class="col-lg-12 d-flex align-items-center">
          <mat-card class="cardWithShadow boxed-esign" style="border-radius: 20px;box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;">
            <ng-container [ngSwitch]="esignLinkItem.ESIGN_STATUT">
              <ng-container *ngSwitchCase="2">
                <mat-card-content class="p-0">
                  <h4 class="f-w-700 f-s-20 m-0 m-t-30" style="text-align: center;">Bienvenue {{ esignLinkItem.ESIGN_S_NOM }} {{ esignLinkItem.ESIGN_S_PRENOM }}</h4>
                  <div class="or-border m-t-8">Signature électronique {{ esignLinkItem.DO_PIECE }} <span style="font-size: 11px; background-color: #7d0000; color: #ffffff; font-weight: 600; padding: 4px; border-radius: 4px; vertical-align: bottom;">EXP : {{ esignLinkItem.ESIGN_DATEEXP_UTC | date : 'dd/MM/yyyy HH:mm' }}UTC</span></div>
                  <div class="m-t-8">
                    <p *ngIf="esignLinkItem.ESIGN_S_MESSAGE" style="background: #c1e5ff; padding: 12px; font-weight: 700;text-align: center;margin-bottom: 0;">{{ esignLinkItem.ESIGN_S_MESSAGE }}</p>
                    <p *ngIf="esignLinkItem.ESIGN_SF_MESSAGE" style="background: #d6d5ff; padding: 12px; font-weight: 700;text-align: center;margin-top: 0;">{{ esignLinkItem.ESIGN_SF_MESSAGE }}</p>
                  </div>
                  <div class="d-flex" style="margin: 12px;">
                    <button mat-flat-button color="ccdark" style="font-weight: 600; border: 1px solid; flex: 1; background: #21ab2d; border-radius: 6px; font-size: 12px; color: black; ">
                        CE DOCUMENT A ÉTÉ SIGNÉ LE {{ esignLinkItem.ESIGN_SF_SIGNED_AT | date : 'dd/MM/yyyy HH:mm' }} UTC
                    </button>
                  </div>
                  <div *ngIf="esignLinkItem.ESIGN_SF_PDFDATA">
                    <div style="width: 100%; height: 100%;">
                      <kendo-pdfviewer [data]="esignLinkItem.ESIGN_SF_PDFDATA" style="height: 100%;"> </kendo-pdfviewer>
                    </div>
                  </div>
                </mat-card-content>
              </ng-container>
              <ng-container *ngSwitchDefault>
                <mat-card-content class="p-0">
                  <h4 class="f-w-700 f-s-20 m-0 m-t-30" style="text-align: center;">Bienvenue {{ esignLinkItem.ESIGN_S_NOM }} {{ esignLinkItem.ESIGN_S_PRENOM }}</h4>
                  <div class="or-border m-t-8">Signature électronique {{ esignLinkItem.DO_PIECE }} <span style="font-size: 11px; background-color: #7d0000; color: #ffffff; font-weight: 600; padding: 4px; border-radius: 4px; vertical-align: bottom;">EXP : {{ esignLinkItem.ESIGN_DATEEXP_UTC | date : 'dd/MM/yyyy HH:mm' }}UTC</span></div>
                  <div class="m-t-8">
                    <p *ngIf="esignLinkItem.ESIGN_S_MESSAGE" style="background: #c1e5ff; padding: 12px; font-weight: 700;text-align: center;margin-bottom: 0;">{{ esignLinkItem.ESIGN_S_MESSAGE }}</p>
                  </div>
                  <div class="d-flex" style="margin: 12px;">
                    <button mat-flat-button color="ccdark" style="font-weight: 600; border: 1px solid; flex: 1; background: #000325; border-radius: 6px; font-size: 12px;" (click)="doOpenMdESignProcessRunModalAction_PUPRemDocsESign()">
                        SIGNER LE DOCUMENT
                    </button>
                  </div>
                  <div *ngIf="esignLinkItem.ESIGN_PDFDATA">
                    <div style="width: 100%; height: 100%;">
                      <kendo-pdfviewer [data]="esignLinkItem.ESIGN_PDFDATA" style="height: 100%;"> </kendo-pdfviewer>
                    </div>
                  </div>
                </mat-card-content>
              </ng-container>
            </ng-container>
        </mat-card>
        </div>
    </div>
  </div>
</ng-container>